/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { UseAccounts } from '../../../hooks/accounts/useAccounts';

const UsageHistory = () => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const getDateAndMonth = (item) => {
    const date = new Date(item.from).getDate();
    const month = monthNames[new Date(item.from).getMonth()];
    return <td>{`${date}-${month}`}</td>;
  };

  const [{ usage, accounts, isLoading }] = UseAccounts();

  return (
    <div className="col-md-12 col-12 pb-4">
      <p className="ml-4">Usage History</p>
      {isLoading ? (
        <div className="text-center">
          <img src="/images/gif.png" alt="Loading..." />
        </div>
      ) : !usage?.length || usage.every((arr) => !arr.length) ? (
        <div className="text-center">
          <p>No usage history available</p>
        </div>
      ) : (
        usage &&
        usage.map((accountUsage, i) => (
          <div className="col-xl-12 col-md-12 mb-4" key={i}>
            <div className="card box shadow h-100 py-2">
              <div className="card-body">
                <p className="font-weight-bold mb-3">
                  {accounts?.[i]?.name || `Account ${i + 1}`}
                </p>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Download</th>
                        <th scope="col">Upload</th>
                      </tr>
                    </thead>
                    <tbody className="lighter_font">
                      {accountUsage.map((item, idx) => (
                        <tr className="text-nowrap" key={idx}>
                          {getDateAndMonth(item)}
                          <td>
                            <i className="fas fa-arrow-down arrow" />
                            {` ${
                              item.uploaded.slice(0, -2) >= 0
                                ? item.uploaded
                                : `0 `
                            }b`}
                          </td>
                          <td>
                            <i className="fas fa-arrow-up arrow" />
                            {` ${
                              item.downloaded.slice(0, -2) >= 0
                                ? item.downloaded
                                : `0 `
                            }b`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

UsageHistory.propTypes = {
  usage: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default UsageHistory;
